import moment from "moment";
import tippy from "tippy.js";

class Time {
  constructor() {
    this.timer = setInterval(this.update, 5000);
  }

  update(full = false) {
    document.querySelectorAll("time.time-ago, time.date").forEach(el => {
      if (el._tippy) return;
      tippy(el, {
        arrow: true,
        delay: [150, 0],
        content: '...',
        onShow(instance) {
          const datetime = instance.reference.getAttribute('datetime');
          if (!datetime) return false;
          instance.setContent(moment(datetime).format('LLL'));
        }
      });
    });

    const elements = document.getElementsByTagName('time');

    for (const element of elements) {
      const datetime = element.getAttribute('datetime');
      if (datetime) {
        let text;
        let classes = element.classList;
        if (classes.contains('time-ago')) {
          text = moment(datetime).fromNow();
        } else if (classes.contains('duration-ago')) {
          text = moment(datetime).fromNow(true);
        } else if (classes.contains('time')) {
          text = moment(datetime).calendar();
        } else if (full && classes.contains('duration')) {
          text = moment.duration(datetime).humanize();
        }
        if (text && element.innerText !== text) {
          element.innerText = text;
        }
      }
    }
  }
}

window._time = new Time();
document.addEventListener('DOMContentLoaded', _ => window._time.update(true));
window.addEventListener("phx:page-loading-stop", _ => window._time.update(true));
document.addEventListener("phx:update", _ => window._time.update(true));
